import React, { useEffect, useState, useRef } from 'react';
import "./Dropdown.scss"

const Dropdown = ({
    busyList = null,
    absentees = null,
    busyText = null,
    optionsList = null,
    optionSelected = null,
    label = null,
    type = null,
    selectedHandler = null,
    handleDelete = null,
    setDelButtons = false,
    sortUp = null,
    sortDown = null,
    isMultiple = false,
    isFirst = false,
    isLast = false,
    itemContent = null
}) => {
    const dropdown = useRef()
    const [list, setList] = useState(null)
    const [selected, setSelected] = useState(optionSelected)
    const [selectedItems, setSelectedItems] = useState(selected ? (isMultiple && Array.isArray(selected) ? selected : [selected]) : [])
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (optionsList) setList(optionsList)
    }, [optionsList])

    useEffect(() => {
        setSelected(optionSelected)
        if (optionSelected && selectedHandler) {
            if (isMultiple && type === 'positions') {
                selectedHandler(selectedItems.map(item => item.id))
            } else {
                selectedHandler(optionSelected.id ? optionSelected.id : optionSelected)
            }
        }
    }, [optionSelected])

    useEffect(() => {
        if (isMultiple && type === 'positions' && selectedItems.length > 0) {
            setSelected(selectedItems[0])
        }
    }, [selectedItems])

    const selectItem = (item, event) => {
        if (isMultiple && type === 'positions' && event.button === 2) {
            event.preventDefault();

            const isAlreadySelected = selectedItems.some(selectedItem =>
                Number(selectedItem.id) === Number(item.id))

            let newSelectedItems;

            if (isAlreadySelected) {
                newSelectedItems = selectedItems.filter(selectedItem =>
                    Number(selectedItem.id) !== Number(item.id))
                setSelectedItems(newSelectedItems)

                // Обновляем selected, если удаленный элемент был текущим selected
                if (selected && Number(selected.id) === Number(item.id)) {
                    setSelected(newSelectedItems.length > 0 ? newSelectedItems[0] : null)
                }
            } else {
                newSelectedItems = [...selectedItems, item]
                setSelectedItems(newSelectedItems)
                setSelected(item)
            }

            if (selectedHandler) {
                selectedHandler(newSelectedItems.map(selectedItem => selectedItem.id))
            }
        } else {
            if (selectedHandler) selectedHandler(item.id ? item.id : item)
            if (item.id) {
                const selectedItem = list.find(el => Number(el.id) === Number(item.id))
                if (selectedItem) {
                    setSelected(selectedItem)
                    if (isMultiple && type === 'positions') {
                        setSelectedItems([selectedItem])
                    }
                }
            } else {
                setSelected(item)
                if (isMultiple && type === 'positions') {
                    setSelectedItems([item])
                }
            }
            setOpen(false)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            document.addEventListener('click', documentClickHandlerDropdown);
            document.addEventListener('contextmenu', (e) => e.preventDefault());
        }, [0])

        return () => {
            document.removeEventListener('click', documentClickHandlerDropdown);
            document.removeEventListener('contextmenu', (e) => e.preventDefault());
        };
    }, []);

    const documentClickHandlerDropdown = (e) => {
        if (!dropdown.current) return;
        if (!dropdown.current.contains(e.target)) {
            setOpen(false)
        }
    };

    return (
        <>
            {list &&
                <div className={"dropdown" + (label ? " with-label" : "") + (type ? ' ' + type : '') + (open ? " open" : "") + (selected ? " selected" : "")} ref={dropdown}>
                    <div className={"dropdown__btn" + (setDelButtons ? " set-del__buttons" : "")} onClick={() => setOpen(!open)}>
                        {label &&
                            <label>{label}</label>
                        }
                        {(type === 'location' || type === 'clinics') && selected &&
                            <>{selected.address.replace('ул.', '')},&nbsp;
                                <span>{selected.description}</span></>
                        }
                        {type === 'services' && selected &&
                            <>{selected.title}</>
                        }
                        {type === 'positions' && selected &&
                            <>{selected.name}{isMultiple && selectedItems && selectedItems.length > 1 && ` (+${selectedItems.length - 1})`}</>
                        }
                        {(type === 'date_part' || type === 'date_part_end') &&
                            <>{selected}</>
                        }
                        {type === 'startHours' &&
                            <>{selected}</>
                        }
                        {type === 'endHours' && selected &&
                            <>{selected.time} <span>{selected.hoursSum}</span></>
                        }
                        {type === 'timeType' && selected &&
                            <>{selected.value}</>
                        }
                        {type === 'specialist' && selected &&
                            <>{selected.name}<span>{selected.positions[selected.position_id[0]] && ", " + selected.positions[selected.position_id[0]].name}</span></>
                        }
                    </div>
                    {setDelButtons &&
                        <div className="dropdown__buttons">
                            <div className="dropdown__buttons-arrows">
                                <div className={`dropdown__buttons-arrow dropdown__buttons-arrows-up ${isFirst ? 'disabled' : ''
                                    }`}
                                    onClick={!isFirst ? sortUp : null}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.00075 2.92262L4.10968 6.81024M8.00075 2.92262L11.8888 6.81068M8.00075 2.92262L8.00075 13.079" stroke="#949594" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div className={`dropdown__buttons-arrow dropdown__buttons-arrows-down ${isLast ? 'disabled' : ''
                                    }`}
                                    onClick={!isLast ? sortDown : null}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.00075 13.0774L4.10968 9.18976M8.00075 13.0774L11.8888 9.18932M8.00075 13.0774L8.00075 2.92102" stroke="#949594" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <button onClick={handleDelete} className="dropdown__buttons-remove">
                            </button>
                        </div>
                    }
                    <div className="dropdown__list g-hide-scrollbar">
                        {list.map((item, index) => {
                            const isSelected = isMultiple && type === 'positions'
                                ? selectedItems.some(selectedItem => selectedItem && Number(selectedItem.id) === Number(item.id))
                                : selected && Number(selected.id) === Number(item.id);

                            let mainPosition = null;
                            if (type === 'specialist') {
                                mainPosition = item.position_id ? item.positions[item.position_id[0]] : 'сотрудник';
                            }

                            return (
                                <button
                                    className={"dropdown__list-item" + (isSelected ? " selected" : "") + (absentees && absentees.includes(item.id) ? " absentees" : "")}
                                    onClick={(e) => selectItem(item, e)}
                                    onContextMenu={(e) => isMultiple && type === 'positions' && selectItem(item, e)}
                                    key={index}
                                    disabled={busyList && busyList.includes(item.id) && item?.id != optionSelected?.id}
                                >
                                    <div className="dropdown__list-item-inner">
                                        {itemContent && itemContent}
                                        {(type === 'location' || type === 'clinics') &&
                                            <>{item.address.replace('ул.', '')},
                                                <span>{item.description}</span></>
                                        }
                                        {type === 'services' &&
                                            <>{item.title}&nbsp;
                                                <span>~&nbsp;{item.duration_formatted}</span></>
                                        }
                                        {type === 'positions' &&
                                            <>{item.name}&nbsp;</>
                                        }
                                        {(type === 'date_part' || type === 'date_part_end') &&
                                            <>{item}</>
                                        }
                                        {type === 'startHours' &&
                                            <>{item}</>
                                        }
                                        {type === 'endHours' &&
                                            <>{item.time} <span className='dropdown__list-item-hours'>{item.hoursSum}</span></>
                                        }
                                        {type === 'timeType' &&
                                            <>{item.value}</>
                                        }
                                        {type === 'specialist' &&
                                            <div className='dropdown__list-item-text'>{item.name}<span>{mainPosition && ", " + mainPosition.name}</span></div>
                                        }
                                        {(busyList && busyList.includes(item.id) && item?.id != optionSelected?.id) &&
                                            <span className='dropdown__list-item-busy'>
                                                {busyText ? busyText : 'Занят'}
                                            </span>
                                        }
                                        {(absentees && absentees.includes(item.id)) &&
                                            <span className='dropdown__list-item-absentees'>
                                                Отсутствует
                                            </span>
                                        }
                                    </div>
                                    
                                </button>
                            )
                        })}
                    </div>
                </div>
            }
        </>
    );
};

export default Dropdown;